export const joiningConfig = {
  sdkKey: '',
  meeting_number: '',
  signature: '',
  user_name: '',
  email: '',
  leaveUrl: '',
};

export const COOKIE_TOKEN_NAME = 'TOKEN_CONTEXT';
export const COOKIE_TOKEN_OPTIONS = {
  path: '/',
  domain: `${process.env.NEXT_PUBLIC_COOKIE_DOMAIN}`,
};
